import { Vector } from "../Vector";
import { Path } from "../Path";

import { DEFAULT_HEXAGON_RADIUS, DEFAULT_HEXAGON_SIDE_WIDTH } from "../../constants";
import { HexagonProps, GetHexagonAttrs } from "./types";

// eslint-disable-next-line max-lines-per-function,id-length
export const getHexagonAttrs = ({
  radius = DEFAULT_HEXAGON_RADIUS,
  sideWidth = DEFAULT_HEXAGON_SIDE_WIDTH,
  flatTop,
}: HexagonProps): GetHexagonAttrs => {
  const realRadius = Math.max(0, Math.min(sideWidth / 2, radius));
  const length = Math.max(0, sideWidth);
  let width;
  let height;
  let point1: Vector;
  let point2: Vector;
  let point3: Vector;
  let point4: Vector;
  let point5: Vector;
  let point6: Vector;

  if (!flatTop) {
    height = length * 2;
    width = (height * Math.sqrt(3)) / 2;
  } else {
    width = length * 2;
    height = (width * Math.sqrt(3)) / 2;
  }

  if (!flatTop) {
    point1 = new Vector(width / 2, 0);
    point2 = new Vector(width, height / 4);
    point3 = new Vector(width, (height * 3) / 4);
    point4 = new Vector(width / 2, height);
    point5 = new Vector(0, (height * 3) / 4);
    point6 = new Vector(0, height / 4);
  } else {
    point1 = new Vector(0, height / 2);
    point2 = new Vector(width / 4, 0);
    point3 = new Vector((width * 3) / 4, 0);
    point4 = new Vector(width, height / 2);
    point5 = new Vector((width * 3) / 4, height);
    point6 = new Vector(width / 4, height);
  }

  const right = Vector.fromAngle(point2.subtract(point1).angle(), realRadius);
  const left = Vector.fromAngle(point6.subtract(point1).angle(), realRadius);
  const level = !flatTop ? new Vector(0, realRadius) : new Vector(realRadius, 0);

  return {
    width: Math.ceil(width),
    height: Math.ceil(height),
    viewBox: `0 0 ${width} ${height}`,
    commands:
      realRadius === 0
        ? new Path([
            Path.M(point1),
            Path.L(point2),
            Path.L(point3),
            Path.L(point4),
            Path.L(point5),
            Path.L(point6),
            Path.Z(),
          ]).toString()
        : new Path([
            Path.M(point1.add(left)),
            Path.Q(point1, point1.add(right)),
            Path.L(point2.subtract(right)),
            Path.Q(point2, point2.add(level)),
            Path.L(point3.subtract(level)),
            Path.Q(point3, point3.add(left)),
            Path.L(point4.subtract(left)),
            Path.Q(point4, point4.subtract(right)),
            Path.L(point5.add(right)),
            Path.Q(point5, point5.subtract(level)),
            Path.L(point6.add(level)),
            Path.Q(point6, point6.subtract(left)),
            Path.Z(),
          ]).toString(),
  };
};
